import { render } from "./PaymentsChart.vue?vue&type=template&id=bf77efd8"
import script from "./PaymentsChart.vue?vue&type=script&lang=js"
export * from "./PaymentsChart.vue?vue&type=script&lang=js"
script.render = render

export default script